/**
 * The known sites still missing data along the Francés, Sarria–Santiago.
 *
 * Not collected by this app: it is a registry the owner already had —
 * accommodation and places to eat pulled from open data, each one already
 * marked with exactly what a public source does not say about it (price,
 * hours, whether it stamps…). What this module adds is a way to walk that
 * list off, in order, instead of starting from an empty map every time.
 *
 * The 77 sites that were already complete were dropped before this file was
 * written: nothing here is worth interrupting a walk for.
 */
import raw from "./pendientes-frances-sarria.json";

/** The two tags a pending site can become, once you stand in front of it. */
export type PendingTag = "alojamiento" | "restaurante";

export interface PendingSite {
  /**
   * Stable across reloads and across re-sorts: derived from the site's own
   * kind and coordinates in the original registry, never from its name —
   * two different sites in this list share the name "Hotel Novoa".
   */
  id: string;
  /** Distance from Sarria, as the registry measured it. */
  km: number;
  /** `null` when the source had none. Shown as "(sin nombre)". */
  nombre: string | null;
  tag: PendingTag;
  lon: number;
  lat: number;
  /** What the registry is missing for this one, in the order it matters. */
  falta: readonly string[];
}

/** Already sorted by `km` when the file was generated; sorted again to be sure. */
export const PENDIENTES: readonly PendingSite[] = (raw as PendingSite[])
  .slice()
  .sort((a, b) => a.km - b.km);

/** "falta: horario, lavadora" — or nothing, for a site that is complete. */
export function pendingSummary(falta: readonly string[]): string {
  return falta.length === 0 ? "" : `falta: ${falta.join(", ")}`;
}

/** "Km 22,08", the way the registry itself measured the distance. */
export function pendingKm(km: number): string {
  return `Km ${km.toFixed(2).replace(".", ",").replace(/,?0+$/, "")}`;
}
